import axios from 'axios';
import { ref } from 'vue';

function formatData(insurer, steps) {
    console.log(insurer, steps);
    // Collect data from all steps
    let data = steps.reduce((acc, step) => {
        return {
            ...acc,
            ...step.data
        };
    }, {});

    console.log(data);

    // Format fields for Formie submission
    data = Object.keys(data).reduce(
        (acc, key) => {
            return {
                ...acc,
                [`fields[${key}]`]: data[key]
            };
        },
        {
            [window.csrfTokenName]: window.csrfTokenValue,
            action: 'formie/submissions/submit',
            submitAction: 'submit',
            handle: `declaration${insurer.toUpperCase()}`,
            siteid: 1
        }
    );
    console.log(data);

    // Create http form data from fields
    const httpFormData = new FormData();
    Object.keys(data).forEach((key) => httpFormData.append(key, data[key]));

    return httpFormData;
}

export function useSubmit() {
    const complete = ref(false);
    const loading = ref(false);
    const error = ref('');

    const handleSuccess = (response) => {
        console.log(response.data);
        if (response.data.success) {
            complete.value = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            error.value = 'There was an error submitting the form. Please try again.';
        }
    };

    const handleError = (error) => {
        error.value = 'There was an error submitting the form. Please try again.';
        console.log(error);
    };

    const submit = (insurer, steps) => {
        loading.value = true;
        error.value = '';

        axios
            .post('/', formatData(insurer, steps), {
                headers: {
                    Accept: 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(handleSuccess)
            .catch(handleError)
            .finally(() => {
                loading.value = false;
            });
    };

    return { submit, complete, error, loading };
}
